import React, { Component } from "react";
import {
  DKLabel,
  DKInput,
  DKButton,
  removeLoader,
  showLoader,
  INPUT_VIEW_DIRECTION,
} from "deskera-ui-library";
import Popup from "./Popup";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import Table from "../../services/table";
import Utility, { deepClone, getRandomNumber } from "../../utility/Utility";
import JobPipelineService from "./Dashboard/JobPipeline";

/*
PROPS
- onCancel
- onSave (columnData)
*/

class AddSegmentPopup extends Component {
  constructor(props) {
    super(props);

    this.colors = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((id) => {
      return "data-grid-badge-color-" + id;
    });
    this.header = `<span style="font-size:30px">📐</span> ${Utility.isEmptyObject(this.props.data) ? 'Add' : 'Edit'} Job Opening`;
    this.headerIcon = "📐";
    this.subHeader =
      "Enter a name to help you remember what this job opening is all about.";

    this.state = {
      segmentName: this.props.data?.name || "",
      selectedColor: this.props.data?.color || this.colors[0],
      canValidate: false,
      data: this.props.data || null
    };
  }
  render() {
    return (
      <Popup>
        <div className="row justify-content-center">
          <DKLabel text={this.header} className="fw-m fs-xl" />
        </div>
        {this.subHeader && (
          <DKLabel
            text={this.subHeader}
            className="text-gray fs-m mt-s text-align-center"
          />
        )}
        <div className="parent-width">
          <DKInput
            autoFocus={true}
            title=""
            value={this.state.segmentName}
            onChange={(text) => {
              this.setState({ segmentName: text });
            }}
            direction={INPUT_VIEW_DIRECTION.VERTICAL}
            className="mt-l"
            required={true}
            canValidate={this.state.canValidate}
            placeHolder="Job name"
          />
          {this.plotColors()}
          <DKLabel
            text="Color will be applied while selecting job opening from Candidate / list"
            className="text-align-center text-gray mt-r"
          />
        </div>
        {this.getFooter()}
      </Popup>
    );
  }

  plotColors() {
    return (
      <div className="row flex-wrap mt-l justify-content-center">
        {this.colors.map((color, index) => {
          return (
            <div
              key={index}
              className={
                color +
                " border-radius-s m-s cursor-hand column justify-content-center align-items-center unselectable"
              }
              style={{ width: 30, height: 30, userSelect: "none" }}
              onClick={() => {
                this.setState({ selectedColor: color });
              }}
            >
              {color === this.state.selectedColor ? "✓" : ""}
            </div>
          );
        })}
      </div>
    );
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  cancelTapped = () => {
    this.props.onCancel();
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getFooter() {
    return (
      <div className="row mt-xxl mb-m justify-content-center">
        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={this.cancelTapped}
        />
        <DKButton
          title={`${Utility.isEmptyObject(this.props.data) ? 'Save' : 'Update'}`}
          className="bg-button text-white ml-m"
          onClick={this.saveSegment}
        />
      </div>
    );
  }
  saveSegment = () => {
    if (this.state.segmentName.trim() === "") {
      this.setState({
        canValidate: true,
      });
      return;
    }

    showLoader("Please wait...");
    let segmentColumn = TableManger.getColumn(
      TABLES.CANDIDATE,
      COLUMN_CODE.CANDIDATE.JOBOPENING
    );
    let options = []
    let reqSegment = {}
    if (!Utility.isEmptyObject(this.props.data)) {
      let segmentList = [...segmentColumn.options]
      let segmentIndex = segmentList.findIndex(segment => segment.id === this.props.data.id)
      if (segmentIndex === -1) {
        return
      }
      let obj = {
        id: this.props.data.id,
        name: this.state.segmentName,
        color: this.state.selectedColor,
      };
      segmentList.splice(segmentIndex, 1, obj)
      options = segmentList
      reqSegment = obj
    } else {
      const newId = parseInt(
        getRandomNumber(1000) + "" + segmentColumn.options.length
      );
      let obj = {
        id: newId,
        name: this.state.segmentName,
        color: this.state.selectedColor,
      };
      options = [...segmentColumn.options, obj];
      reqSegment = obj
    }
    segmentColumn.options = options.filter(obj=> typeof obj.id === "number");
    Table.updateColumn(segmentColumn, TableManger.getTableId(TABLES.CANDIDATE))
      .finally(() => removeLoader())
      .then((data) => {
        Table.getTable(TableManger.getTableId(TABLES.CANDIDATE)).then((res) => {
          let columns = deepClone(res)
          this.updateColumnsForCandidate(columns);
          TableManger.setTableColumns(columns, TABLES.CANDIDATE);
          
          this.props.onSave(false, reqSegment);
        },error=>{
          this.props.onSave(false, reqSegment);
        });
        
      });
  };
  updateColumnsForCandidate(columnsNew) {
    let columns = columnsNew?.columnsMetaData ? columnsNew.columnsMetaData : [];
    if(columns && columns.length > 0) {
      const pipelineData = JobPipelineService.getPipelineData(JobPipelineService.pipelineData);
      const stageData = JobPipelineService.getStageDataWithPipelineName(JobPipelineService.stageData, pipelineData);
      const segmentColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING);
      const statusColumnId = TableManger.getColumnId(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.STATUS);
      columnsNew?.columnsMetaData?.forEach(column => {
        if(column && column.id === segmentColumnId) {
          let newOptionsSegment = column?.options?.filter(op=>typeof op.id === 'number')
          pipelineData.forEach(element => {
            const isPresent = newOptionsSegment.some(x=> x.id == element.id);
            if (!isPresent) {
              newOptionsSegment.push(element);
            }
          });
          column.options = newOptionsSegment;
        }
        if (column && column.id === statusColumnId) {
          let newOptions = []
          const status = column?.options?.filter(o=>o.id == '1' || o.id == '2')||[];
          stageData.forEach(element => {

            const isPresent = newOptions.some(x => x.id === element.id);
            if (!isPresent) {
              newOptions.push(element);
            }

          });
          column.options = [...status,...newOptions];
        }
        if(column && ( column.columnCode === 'userId')) {
          column.hidden = true;
        }
      });
    }
  }
  
}

export default AddSegmentPopup;
